import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-36 right-4 z-[90] space-y-2"
}
const _hoisted_2 = { class: "flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-sm font-medium truncate" }
const _hoisted_5 = { class: "flex items-center gap-1 flex-shrink-0" }

import { watch } from 'vue'
import { useDocumentViewer } from '@/composables/useDocumentViewer'
import { useDocumentsStore } from '@/views/Documents/store'
import { Button } from '@/components/ui/button'
import { FileText, Maximize2, X, Loader2 } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentViewerWidget',
  setup(__props) {

const {
  isMinimized,
  currentDocumentId,
  minimizedDocuments,
  restoreFromMinimized,
  removeFromMinimized,
  addToMinimized,
} = useDocumentViewer()

const documentsStore = useDocumentsStore()

// When restored from storage as minimized, fetch the doc and add to minimized list
watch(
  [isMinimized, currentDocumentId, () => minimizedDocuments.value.length],
  async ([minimized, docId, count]) => {
    if (minimized && docId && count === 0) {
      const doc = await documentsStore.fetchDocumentById(docId)
      if (doc) {
        addToMinimized(doc)
      }
    }
  },
  { immediate: true },
)

const handleRestore = (docId: string) => {
  restoreFromMinimized(docId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "leave-active-class": "transition-all duration-200 ease-in",
    "enter-from-class": "opacity-0 translate-y-4 scale-95",
    "enter-to-class": "opacity-100 translate-y-0 scale-100",
    "leave-from-class": "opacity-100 translate-y-0 scale-100",
    "leave-to-class": "opacity-0 translate-y-4 scale-95"
  }, {
    default: _withCtx(() => [
      (_unref(isMinimized) && _unref(minimizedDocuments).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(minimizedDocuments), (doc) => {
              return (_openBlock(), _createElementBlock("div", {
                key: doc.id,
                class: "bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-64"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(FileText), { class: "h-4 w-4 text-primary" })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(doc.title), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Minimizado", -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "h-7 w-7",
                    onClick: ($event: any) => (handleRestore(doc.id)),
                    title: "Restaurar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Maximize2), { class: "h-3.5 w-3.5" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                    onClick: ($event: any) => (_unref(removeFromMinimized)(doc.id)),
                    title: "Cerrar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})